// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2uoi1","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__smxgi"};